import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../../GlobalVars';

interface Token {
  accessToken: string | null;
  refreshToken: string | null;
  preserveToken: string | null;
}

export const initialState: Token = {
  accessToken: null,
  refreshToken: null,
  preserveToken: 'false',
};

const tokenSlice = createSlice({
  name: 'tokens',
  initialState,
  reducers: {
    saveAccessToken: (state, action) => {
      const { preserveToken } = state;
      const { payload } = action;

      axios.defaults.headers.common = { Authorization: `Bearer ${payload}` };

      if (preserveToken === 'true') {
        localStorage.setItem(ACCESS_TOKEN, payload || '');
      } else {
        sessionStorage.setItem(ACCESS_TOKEN, payload || '');
      }

      state.accessToken = payload;
    },
    saveRefreshToken: (state, action) => {
      const { preserveToken } = state;
      const { payload } = action;

      if (preserveToken === 'true') {
        localStorage.setItem(REFRESH_TOKEN, payload || '');
      } else {
        sessionStorage.setItem(REFRESH_TOKEN, payload || '');
      }

      state.refreshToken = payload;
    },
    deleteTokens: (state) => {
      const isLocal = localStorage.getItem(ACCESS_TOKEN) || false;

      if (isLocal) {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(REFRESH_TOKEN);
      } else {
        sessionStorage.removeItem(ACCESS_TOKEN);
        sessionStorage.removeItem(REFRESH_TOKEN);
      }

      state.accessToken = null;
      state.refreshToken = null;
    },
    shouldPreserveTokens: (state, action) => {
      const { payload } = action;
      state.preserveToken = payload;
    },
  },
});

export const {
  saveAccessToken,
  saveRefreshToken,
  deleteTokens,
  shouldPreserveTokens,
} = tokenSlice.actions;

export default tokenSlice.reducer;
